import React from 'react';
import { NavLink } from 'react-router-dom';
import i18n from '../../i18n';
import { getLoggedUser } from '../../state/user';
import { getNotificationCounts } from '../../models/payments';
import { SideBarMob } from './sidebar-mob';
import { getUserInfo } from '../../models/users';
import { generateMzadcomID } from '../../state/utils';
import { CreditCard, Forklift, List, MapPin, Truck } from 'lucide-react';

const user = getLoggedUser();
let is_logged = localStorage.getItem('is_logged_in') ? true : false;
const allowed_roles = ['CE', 'GM'];

function logout() {
  localStorage.clear();
  window.location.href = '/';
}

export class SideBar extends React.Component {
  constructor() {
    super();
    this.state = {
      dashboard_menu_expand: false,
      report_menu_expand: false,
      wallet_amount: 0,
    };
    this.notificationCheck = this.notificationCheck.bind(this);
  }

  componentDidMount() {
    if (user && allowed_roles.includes(user.role) ? true : false) {
      this.notificationCheck();
      setInterval(() => {
        this.notificationCheck();
      }, 60000);
    }
  }

  async checkUserWallet() {
    this.setState({ is_loading: true });
    const response = await getUserInfo(user.id);
    if (response && response.success) {
      let data = response.data;
      this.setState({ is_loading: false });
      this.setState({ wallet_amount: data.wallet_amount });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async notificationCheck() {
    let response = await getNotificationCounts();
    let data = response.data;
    this.setState({
      pendingMzadcomPayment: data.mzadcom_payment_count,
      pendingSupplierPayment: data.supplier_auction_count,
      pendingAuctionPayment: data.auction_payment_count,
    });
  }



  render() {
    let { count, wallet_amount } = this.state;
    let lang = localStorage.getItem('I18N_LANGUAGE');
    return (
      <React.Fragment>
        {is_logged && (
          <div>
            <SideBarMob wallet_amount={wallet_amount} />
            <div className="row mb-5 d-mob-none px-4">
              {/* <div className="col-md-12">
                <div className="dashboard-bg rounded-4 text-center text-white fwb fs32 py-4 mb-3">
                  <img
                    className="px-2"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/dashboard-icon.png"
                    }
                    alt="Dashboard Icon"
                  />
                  <span className="dashboard-text">{i18n.t("dashboard")}</span>
                </div>
              </div> */}

              <div className="card bg-white border-0" style={{ margin: '0', padding: '0' }}>
                <div className="card-body user-brd rounded-4 mt-1 mx-3 mb-2">
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="my-4 profile-img">
                      {user.avatar && (
                        <img
                          src={user.avatar}
                          alt="user"
                          className="rounded rounded-lg"
                          referrerPolicy="no-referrer"
                          width={170}
                        />
                      )}
                      {!user.avatar && (
                        <img
                          src={process.env.PUBLIC_URL + '/assets/images/dash-user.png'}
                          alt="Admin User Icon"
                          width={170}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="fs14 text-primary text-center pb-2">
                  <div className="fs24 text-primary lh28">{user.name}</div>
                  <div className="text-gray fs10">{user.email}</div>
                  <div>{generateMzadcomID(user.id, user.role)}</div>
                  {/* <span className="text-gray"> {i18n.t("mobile")}: </span>
                    {user.mobile}
                    <br /> */}
                  {/* <span className="text-gray"> {i18n.t("employee_id")}: </span> */}
                  {/* <br />
                    <span className="text-gray">{i18n.t("email")}: </span>
                    {user.email} */}
                </div>
              </div>

              <hr className="px-3" />

              <div className="card bg-white mt-1 border-0" style={{ margin: '0', padding: '0' }}>
                <div className="item1-links  mb-0">
                  {['U', 'CE', 'GM', 'C', 'RS', 'O'].includes(user.role) && (
                    <NavLink activeClassName="active" to="/dashboard" className="d-flex border-bottom">
                      <img
                        src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub1.png'}
                        alt=""
                        height="20"
                        width="20"
                        className="mx-3"
                      />
                      {i18n.t('dashboard')}
                    </NavLink>
                  )}
                  {!['U', 'CE', 'GM', 'C', 'RS', 'O'].includes(user.role) && (
                    <div>
                      <a
                        className="d-flex align-items-center justify-content-between border-bottom"
                        href={true}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            dashboard_menu_expand: !this.state.dashboard_menu_expand,
                          });
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          <img
                            src={process.env.PUBLIC_URL + '/assets/images/dashboard-left-menu-icon.png'}
                            alt=""
                            height="20"
                            width="20"
                            className="mx-3"
                          />
                          {i18n.t('dashboard')}
                        </div>
                        <span className="icon1 mx-3">
                          <i
                            className={this.state.dashboard_menu_expand ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}
                          ></i>
                        </span>
                      </a>
                      <div className={this.state.dashboard_menu_expand ? 'm-2' : 'd-none m-3'}>
                        <NavLink activeClassName="active" to="/dashboard" className="d-flex border-bottom">
                          <img
                            src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub1.png'}
                            alt=""
                            height="20"
                            width="20"
                            className="mx-3"
                          />
                          {i18n.t('live_dashboard')}
                        </NavLink>
                        <NavLink activeClassName="active" to="/dashboard-auc-eval" className="d-flex border-bottom">
                          <img
                            src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub2.png'}
                            alt=""
                            height="20"
                            width="20"
                            className="mx-3"
                          />
                          {i18n.t('auction_evaluation')}
                        </NavLink>
                        <NavLink
                          activeClassName="active"
                          to="/dashboard-user-analysis"
                          className="d-flex border-bottom"
                        >
                          <img
                            src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub3.png'}
                            alt=""
                            height="20"
                            width="20"
                            className="mx-3"
                          />
                          {i18n.t('user_analysis')}
                        </NavLink>
                        <NavLink activeClassName="active" to="/dashboard-sales-eval" className="d-flex border-bottom">
                          <img
                            src={process.env.PUBLIC_URL + '/assets/images/dashboard-sub4.png'}
                            alt=""
                            height="20"
                            width="20"
                            className="mx-3"
                          />
                          {i18n.t('sales_evaluation')}
                        </NavLink>
                        {/* <NavLink
                          activeClassName="active"
                          to="/dashboard-auc-materials"
                          className="d-flex border-bottom"
                        >
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/dashboard-sub5.png"
                            }
                            alt=""
                            height="20"
                            width="20"
                            className="mx-3"
                          />
                          {i18n.t("auction_materials")}
                        </NavLink> */}
                      </div>
                    </div>
                  )}

                  <NavLink activeClassName="active" to="/profile" className="d-flex border-bottom">
                    <span className="icon1 mx-3">
                      <i className="icon icon-user"></i>
                    </span>{' '}
                    {i18n.t('edit_profile')}
                  </NavLink>

                  {/* Finance Sections */}
                  {['F'].includes(user.role) && (
                    <NavLink activeClassName="active" to="/auction-payment" className="d-flex  border-bottom">
                      <span className="icon1 mx-3">
                        <CreditCard className="nav-icon-svg" strokeWidth={2} />
                      </span>{' '}
                      {i18n.t('auction_payments')}
                      {user.role === 'F' && this.state.pendingAuctionPayment > 0 && (
                        <span className="count-badge">{this.state.pendingAuctionPayment}</span>
                      )}
                    </NavLink>
                  )}

                  {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M' ||
                    user.role === 'O' ||
                    user.role === 'RS') && (
                      <div>
                        {/* <NavLink
                        to="/live_activity"
                        activeClassName="active"
                        className="d-flex  border-bottom"
                        target="_blank"
                      >
                        <span className="icon1 mx-3">
                          <i className="fa fa-desktop"></i>
                        </span>{" "}
                        {i18n.t("live_activity")}
                      </NavLink> */}

                        <NavLink to="/users" activeClassName="active" className="d-flex  border-bottom">
                          <span className="icon1 mx-3">
                            <i className="fa fa-users"></i>
                          </span>{' '}
                          {i18n.t('users')}
                        </NavLink>

                        {(user.role === 'RS' ||
                          user.role === 'A' ||
                          user.role === 'PM' ||
                          user.role === 'M' ||
                          user.role === 'OM') && (
                            <NavLink to="/officers" activeClassName="active" className="d-flex  border-bottom">
                              <span className="icon1 mx-3">
                                <i className="fa fa-address-card"></i>
                              </span>{' '}
                              {i18n.t('officers')}
                            </NavLink>
                          )}

                        {(user.role === 'RS' ||
                          user.role === 'A' ||
                          user.role === 'PM' ||
                          user.role === 'M' ||
                          user.role === 'OM') && (
                            <NavLink to="/meetings" activeClassName="active" className="d-flex  border-bottom">
                              <span className="icon1 mx-3">
                                <i className="fa fa-calendar-o"></i>
                              </span>{' '}
                              {i18n.t('schedule')} {i18n.t('weekly')} {i18n.t('meetings')}
                            </NavLink>
                          )}

                        {(user.role === 'RS' || user.role === 'A' || user.role === 'O') && (
                          <NavLink to="/todays-meeting" activeClassName="active" className="d-flex  border-bottom">
                            <span className="icon1 mx-3">
                              <i className="fa fa-calendar"></i>
                            </span>{' '}
                            {i18n.t('todays')} {i18n.t('meeting')}
                          </NavLink>
                        )}

                        {/* <NavLink
                        to="/clients"
                        activeClassName="active"
                        className="d-flex  border-bottom"
                      >
                        <span className="icon1 mx-3">
                          <i className="mdi mdi-account-multiple"></i>
                        </span>{" "}
                        {i18n.t("clients")}
                      </NavLink> */}
                      </div>
                    )}

                  {['A', 'F', 'CE', 'GM'].includes(user.role) && (
                    <div>
                      <NavLink to="/users-wallet" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <i className="fa fa-money"></i>
                        </span>
                        <span className="text-justify">
                          {i18n.t('mzadcom')} - {i18n.t('wallet')}
                        </span>
                      </NavLink>
                      <NavLink to="/withdraw-requests" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <i className="fa fa-undo"></i>
                        </span>
                        <span className="text-justify">{i18n.t('withdraw_requests')}</span>
                      </NavLink>
                    </div>
                  )}

                  {user.role === 'A' && (
                    <NavLink to="/groups" activeClassName="active" className="d-flex  border-bottom">
                      <span className="icon1 mx-3">
                        <i className="fa fa-object-group"></i>
                      </span>{' '}
                      {i18n.t('groups')}
                    </NavLink>
                  )}

                  {/* {user.role === "A" && (
                    <NavLink
                      to="/masks"
                      activeClassName="active"
                      className="d-flex  border-bottom"
                    >
                      <span className="icon1 mx-3">
                        <i className="icon icon-layers"></i>
                      </span>{" "}
                      {i18n.t("masks")}
                    </NavLink>
                  )} */}
                  {user.role === 'A' && (
                    <>
                      <NavLink to="/categories" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <i className="fa fa-list-alt"></i>
                        </span>{' '}
                        {i18n.t('categories')}
                      </NavLink>
                      <NavLink to="/departments" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <i className="mdi mdi-file-tree"></i>
                        </span>{' '}
                        {i18n.t('departments')}
                      </NavLink>
                      <NavLink to="/locations" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <i className="mdi mdi-map-marker-multiple"></i>
                        </span>{' '}
                        {i18n.t('locations')}
                      </NavLink>
                      <NavLink to="/sub-divisions" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <i className="mdi mdi-file-tree"></i>
                        </span>{' '}
                        {i18n.t('sub_divisions')}
                      </NavLink>
                    </>
                  )}
                  {/* {user.role === "A" && (
                    <NavLink
                      to="/organizations"
                      activeClassName="active"
                      className="d-flex  border-bottom"
                    >
                      <span className="icon1 mx-3">
                        <i className="fa fa-building"></i>
                      </span>{" "}
                      {i18n.t("organizations")}
                    </NavLink>
                  )} */}
                  {user.role === 'A' && (
                    <NavLink to="/banners" activeClassName="active" className="d-flex  border-bottom">
                      <span className="icon1 mx-3">
                        <i className="fa fa-image"></i>
                      </span>{' '}
                      {i18n.t('banners')}
                    </NavLink>
                  )}
                  {user.role === 'A' && (
                    <NavLink to="/blacklist" activeClassName="active" className="d-flex  border-bottom">
                      <span className="icon1 mx-3">
                        <i className="fa fa-ban"></i>
                      </span>{' '}
                      {i18n.t('blacklist')}
                    </NavLink>
                  )}
                  {user.role === 'A' && (
                    <NavLink to="/auction/create" activeClassName="active" className="d-flex  border-bottom">
                      <span className="icon1 mx-3">
                        <i className="icon icon-plus"></i>
                      </span>{' '}
                      {i18n.t('create_auction')}
                    </NavLink>
                  )}

                  {(user.role === 'C' ||
                    user.role === 'RS' ||
                    user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'M' ||
                    user.role === 'OM') && (
                      <>
                        <NavLink to="/auction_request" activeClassName="active" className="d-flex  border-bottom">
                          <span className="icon1 mx-3">
                            <i className="fa fa-exchange"></i>
                          </span>{' '}
                          {i18n.t('auction_request')}
                        </NavLink>
                        {/* <NavLink
                        to="/auction_approval_cl"
                        activeClassName="active"
                        className="d-flex  border-bottom"
                      >
                        <span className="icon1 mx-3">
                          <i className="fa fa-check-circle"></i>
                        </span>{" "}
                        {i18n.t("auction_approval")}
                      </NavLink> */}
                      </>
                    )}

                  {(user.role === 'HSE' || user.role === 'PM' || user.role === 'O') && (
                    <>


                      <NavLink to="/loading-management" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <Forklift className="icon icon-diamond" strokeWidth={2} />
                        </span>
                        {i18n.t('loading_management')}
                      </NavLink>


                      <NavLink to="/vehicles" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <Truck className="icon icon-diamond" strokeWidth={2} />
                        </span>
                        {i18n.t('vehicles')}
                      </NavLink>


                      {/* <NavLink to="/delivery-schedule-list" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                         <List className="icon icon-diamond" strokeWidth={2} />
                        </span>
                        {i18n.t('delivery_schedule_list')}
                      </NavLink> */}

                      <NavLink to="/delivery-site-list" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <List className="icon icon-diamond" strokeWidth={2} />
                        </span>
                        {i18n.t('delivery_site_list')}
                      </NavLink>

                      <NavLink to="/weighbridge-ticket-list" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <List className="icon icon-diamond" strokeWidth={2} />
                        </span>
                        {i18n.t('weighbridge_ticket_list')}
                      </NavLink>

                      <NavLink to="/site-visit-projects" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <MapPin className="icon icon-diamond" strokeWidth={2} />
                        </span>
                        {i18n.t('site_visit_projects')}
                      </NavLink>

                      <NavLink to="/site-visit-requests" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <MapPin className="icon icon-diamond" strokeWidth={2} />
                        </span>
                        {i18n.t('site_visit_req')}
                      </NavLink>

                    </>
                  )}

                  {(user.role === 'A' ||
                    user.role === 'C' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M') && (
                      <NavLink to="/auctions-list" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <i className="icon icon-diamond"></i>
                        </span>{' '}
                        {i18n.t('my_auctions')}
                      </NavLink>
                    )}

                  {(user.role === 'A' || user.role === 'PM' || user.role === 'OM' || user.role === 'F') && (
                    <NavLink to="/auction_approval" activeClassName="active" className="d-flex  border-bottom">
                      <img
                        src={process.env.PUBLIC_URL + '/assets/images/image 25.png'}
                        alt=""
                        width="20"
                        height="20"
                        className="px-2 mx-3"
                      />
                      {i18n.t('auction_approval')}
                    </NavLink>
                  )}

                  {(user.role === 'A' || user.role === 'PM' || user.role === 'OM' || user.role === 'C') && (
                    <NavLink to="/winners_approval" activeClassName="active" className="d-flex  border-bottom">
                      <span className="mx-3">
                        <i className="mdi mdi-trophy-award" />
                      </span>
                      {i18n.t('winners_approval')}
                    </NavLink>
                  )}

                  {user.role === 'A' && (
                    <NavLink to="/approved_auctions" activeClassName="active" className="d-flex  border-bottom">
                      <span className="mx-3">
                        <i className="mdi mdi-checkbox-marked-circle-outline"></i>
                      </span>
                      {i18n.t('approved_auctions')}
                    </NavLink>
                  )}
                  {user.role === 'U' && (
                    <NavLink activeClassName="active" to="/my_auctions" className="d-flex  border-bottom">
                      <img
                        src={process.env.PUBLIC_URL + '/assets/images/solar_key-outline.png'}
                        alt=""
                        height="20"
                        width="20"
                        className="mx-3"
                      />
                      {i18n.t('my_bids')}
                    </NavLink>
                  )}
                  {user.role === 'U' && (
                    <NavLink activeClassName="active" to="/enrolled_auctions" className="d-flex  border-bottom">
                      <img
                        src={process.env.PUBLIC_URL + '/assets/images/auctions-left-menu-icon.png'}
                        alt=""
                        height="20"
                        width="20"
                        className="mx-3"
                      />
                      {i18n.t('enrolled_auctions')}
                    </NavLink>
                  )}
                  {(user.role === 'A' || user.role === 'HSE' || user.role === 'F' || user.role === 'PM') && (
                    <NavLink to="/auction-status" activeClassName="active" className="d-flex  border-bottom">
                      <span className="icon1 mx-3">
                        <i class="fa fa-check-square" aria-hidden="true"></i>
                      </span>{' '}
                      {i18n.t('auction_report')}
                    </NavLink>
                  )}
                  {user.role === 'U' && (
                    <>
                      <NavLink activeClassName="active" to="/winning_bids" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <i className="icon icon-trophy"></i>
                        </span>{' '}
                        {i18n.t('winning_bids')}
                      </NavLink>

                      <NavLink activeClassName="active" to="/rop-payment" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <CreditCard className="icon icon-diamond" />
                        </span>{' '}
                        {i18n.t('rop_payment')}

                        {this.state.pendingMzadcomPayment > 0 && (
                          <span className="count-badge">{this.state.pendingMzadcomPayment}</span>
                        )}
                      </NavLink>
                    </>


                  )}

                  {user.role !== 'O' && (
                    <NavLink activeClassName="active" to="/site_visit" className="d-flex  border-bottom">
                      <span className="icon1 mx-3">
                        <i className="icon icon-credit-card"></i>
                      </span>{' '}
                      {i18n.t('site_visit')}
                    </NavLink>
                  )}

                  {user.role === 'U' && (
                    <NavLink activeClassName="active" to="/wallet" className="d-flex  border-bottom">
                      <img
                        src={process.env.PUBLIC_URL + '/assets/images/mzadcom-wallet-left-menu-icon.png'}
                        alt=""
                        height="20"
                        width="20"
                        className="mx-3"
                      />
                      {i18n.t('my_wallet')}
                    </NavLink>
                  )}

                  {(user.role === 'A' || user.role === 'C' || user.role === 'M') && (
                    <NavLink activeClassName="active" to="/payments" className="d-flex border-bottom">
                      <span className="icon1 mx-3">
                        <i className="icon icon-credit-card"></i>
                      </span>{' '}
                      {i18n.t('payment')}
                    </NavLink>
                  )}

                  {(user.role === 'A' || user.role === 'PM' || user.role === 'OM') && (
                    <NavLink activeClassName="active" to="/client-payments" className="d-flex border-bottom">
                      <span className="icon1 mx-3">
                        <i className="mdi mdi-bank"></i>
                      </span>{' '}
                      {i18n.t('client_payment')}
                    </NavLink>
                  )}

                  {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'F' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE') && (
                      <NavLink activeClassName="active" to="/refund" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <i className="fa fa-money"></i>
                        </span>{' '}
                        {i18n.t('refund')} &nbsp;
                        {allowed_roles.includes(user.role) && (
                          <span className="badge rounded-circle badge-notification bg-danger">{count}</span>
                        )}
                      </NavLink>
                    )}

                  <NavLink activeClassName="active" to="/auction_tracker" className="d-flex border-bottom">
                    <span className="icon1 mx-3">
                      <i className="mdi mdi-history"></i>
                    </span>{' '}
                    {i18n.t('track_auctions')}
                  </NavLink>

                  {(user.role === 'U' &&
                    <NavLink activeClassName="active" to="/auction_liked" className="d-flex  border-bottom">
                      <span className="icon1 mx-3">
                        <i className="icon icon-like"></i>
                      </span>{' '}
                      {i18n.t('liked_auctions')}
                    </NavLink>
                  )}

                  {(user.role === 'U' &&
                    <NavLink activeClassName="active" to="/auction_wishlisted" className="d-flex  border-bottom">
                      <span className="icon1 mx-3">
                        <i className="icon icon-heart"></i>
                      </span>{' '}
                      {i18n.t('wishlisted_auctions')}
                    </NavLink>
                  )}

                  {(user.role === 'A' ||
                    user.role === 'C' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'F' ||
                    user.role === 'M') && (
                      <div>
                        <NavLink activeClassName="active" to="/enrolled_users" className="d-flex  border-bottom">
                          <span className="icon1 mx-3">
                            <i className="icon icon-credit-card"></i>
                          </span>{' '}
                          {i18n.t('enrolled_users')}
                        </NavLink>
                        <a
                          href={true}
                          className="d-flex  border-bottom"
                          onClick={() => {
                            this.setState({
                              report_menu_expand: !this.state.report_menu_expand,
                            });
                          }}
                        >
                          <span className="icon1 mx-3">
                            <i className={this.state.report_menu_expand ? 'fa fa-minus' : 'fa fa-plus'}></i>
                          </span>
                          <span>{i18n.t('reports')}</span>
                          <span
                            className="icon1 mx-3"
                            style={{
                              position: 'absolute',
                              right: lang === 'en' ? 0 : 'auto',
                              left: lang === 'ar' ? 0 : 'auto',
                            }}
                          >
                            <i className={this.state.report_menu_expand ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}></i>
                          </span>
                        </a>
                        <div className={this.state.report_menu_expand ? 'm-2' : 'd-none m-3'}>
                          {/* {
                      this.state.report_menu_expand ? "m-3" : "d-none m-3"
                    } */}
                          <NavLink
                            activeClassName="active"
                            to="/auction_bid_report"
                            className="d-flex border-bottom text-danger"
                          >
                            <span className="icon1 mx-3">
                              <i className="fa fa-file-o"></i>
                            </span>{' '}
                            {i18n.t('auction_bid_report')}
                          </NavLink>
                          <NavLink activeClassName="active" to="/winners" className="d-flex border-bottom text-danger">
                            <span className="icon1 mx-3">
                              <i className="fa fa-flag-o"></i>
                            </span>{' '}
                            {i18n.t('auction_winners')}
                          </NavLink>
                          {(user.role === 'A' ||
                            user.role === 'PM' ||
                            user.role === 'OM' ||
                            user.role === 'GM' ||
                            user.role === 'CE' ||
                            user.role === 'M') && (
                              <div>
                                <NavLink
                                  to="/sales_report"
                                  activeClassName="active"
                                  className="d-flex border-bottom text-danger"
                                >
                                  <span className="icon1 mx-3">
                                    <i className="fa fa-money"></i>
                                  </span>{' '}
                                  {i18n.t('sales_report')}
                                </NavLink>
                                <NavLink
                                  to="/final_report"
                                  activeClassName="active"
                                  className="d-flex border-bottom text-danger"
                                >
                                  <span className="icon1 mx-3">
                                    <i className="fa fa-hourglass-end"></i>
                                  </span>{' '}
                                  {i18n.t('final_report')}
                                </NavLink>
                                <NavLink
                                  to="/position_report"
                                  activeClassName="active"
                                  className="d-flex border-bottom text-danger"
                                >
                                  <span className="icon1 mx-3">
                                    <i className="fa fa-key"></i>
                                  </span>{' '}
                                  {i18n.t('position_report')}
                                </NavLink>
                                <NavLink
                                  to="/wallet_summary"
                                  activeClassName="active"
                                  className="d-flex border-bottom text-danger"
                                >
                                  <span className="icon1 mx-3">
                                    <i className="fa fa-google-wallet"></i>
                                  </span>{' '}
                                  {i18n.t('wallet_summary')}
                                </NavLink>
                              </div>
                            )}
                          <NavLink to="/reports" activeClassName="active" className="d-flex border-bottom text-danger">
                            <span className="icon1 mx-3">
                              <i className="icon icon-chart"></i>
                            </span>{' '}
                            {i18n.t('reports')}
                          </NavLink>
                        </div>
                      </div>
                    )}



                  {(user.role === 'A' ||
                    user.role === 'PM' ||
                    user.role === 'OM' ||
                    user.role === 'GM' ||
                    user.role === 'CE' ||
                    user.role === 'M') && (
                      <NavLink to="/composer" activeClassName="active" className="d-flex  border-bottom">
                        <span className="icon1 mx-3">
                          <i className="fa fa-bell-o"></i>
                        </span>{' '}
                        {i18n.t('composer')}
                      </NavLink>
                    )}

                  <a href={true} onClick={logout} style={{ cursor: 'pointer' }} className="d-flex">
                    <span className="icon1 mx-3">
                      <i className="icon icon-power"></i>
                    </span>{' '}
                    {i18n.t('logout')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
